
















































import { Component, Vue } from "vue-property-decorator";
import ContentHeader from "@/components/ContentHeader.vue";
import AppStorage from "@/appStorage";
import * as Contentful from "contentful";
import { ContentfulClientApi } from "contentful";
import { IStartPage } from "@/contentful/models";
import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";
import Box from "@/components/Box.vue";
import BoxNews from "@/components/BoxNews.vue";
import BoxWithImage from "@/components/BoxWithImage.vue";
import { ContentPageId } from "@/main";
import { ArticleListItemModel } from "@/contentful/articleModel";

@Component({
  components: {
    ContentHeader,
    Box,
    BoxWithImage,
    BoxNews,
  },
  metaInfo: {
    title: "Medlemssidorna - Start",
  },
})
export default class Home extends Vue {
  public loading = true;
  public storage: AppStorage = Vue.AppStorage;
  public content: IStartPage | null = null;
  public newsItem: ArticleListItemModel | null = null;
  contentfulClient: ContentfulClientApi = Contentful.createClient({
    space: this.storage.contentfulSpace,
    accessToken: this.storage.contentfulAccessToken,
  });

  htmlToString(document: Document): string {
    return documentToHtmlString(document);
  }

  latestNews(): void {
    this.contentfulClient
      .getEntries({
        content_type: "article",
        limit: 1,
        order: "-sys.createdAt",
      })
      .then((response: any) => {
        if (response.items.length > 0) {
          this.newsItem = response.items[0];
        }
      });
  }

  boxes(): void {
    if (Vue.AppStorage.startPage) {
      this.content = Vue.AppStorage.startPage;
      this.loading = false;
    } else {
      window.setTimeout(() => {
        // eslint-disable-next-line
        this.contentfulClient.getEntry(ContentPageId.Home).then((response: any) => {
          this.loading = false;
          this.content = response;
          Vue.AppStorage.startPage = this.content;
        });
      }, 500);
    }
  }

  mounted(): void {
    this.boxes();
    this.latestNews();
  }
}
